import DisclaimerBox from "../../../../src/components/DisclaimerBox";
import * as React from 'react';
export default {
  DisclaimerBox,
  React
};